import { showFormatedDate, showFormattedTime, showFormatedDateandTime } from '../../../../../actions/utilAction';
import classNames from 'classnames';
import { renderTextField, renderCheckBox, renderTimePicker, renderTextArea } from '../../../../../components/reduxFields';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux';
// import PatientInfo from '../../../patient_info';
import React from 'react';
import history from '../../../../../history';
import moment from 'moment';
import SignatureModal from './patient_signature_modal';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import { getPatientSingleEncounter, saveEncounterSigns, savePatientEncounter } from '../actions';
import { getMasterData} from '../../../../scheduling/components/SessionNotes_SOAR/actions/soapActions';
import { getGeoLocation } from '../../../../AppConfig/actions';

class EncounterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSign: false,
      appointmentTypeName: '',
      appointmentDate: null,
      appointmentTime: null,
      staffName: '',
      serviceFacility: '',
      isDirectService: false,
      PatientLocationName: '',
      EmployeeSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      appointmentId: props.match.params.apptId,
      encounterId: props.match.params.encId,
      Signee: [],
      patient_id: null,
      staffID: null,      
      timeDifference: 0.0,
      master_data: props.master_data,
      targetCaseManager: '',
      medicaidId: '',     
      leadAnalystMedicaidId: '',     
      behaviorTechnicianMedicaidId: '',
    };
  }
  componentWillMount() {
    this.props.getMasterData();
    let searchObj = {
      'apptId': this.state.appointmentId,
      'encounterId': this.state.encounterId,
    };
    this.props.getPatientSingleEncounter(searchObj);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.singleEncounter && nextProps.singleEncounter !== this.props.singleEncounter) {
      let appointmentData = nextProps.singleEncounter.patientAppointment;
      if (appointmentData) {
        let staffIds = [];
        let staffNames = [];
        let medicaidIds = [];
        let leadAnalystMedicaidIds = [];
        let behaviorTechnicianMedicaidIds = [];
        appointmentData.appointmentSingleStaff.forEach((staff) => {
          staffIds.push(staff.staffId);
          staffNames.push(staff.staffName);
          medicaidIds.push(staff.medicaidId);
          leadAnalystMedicaidIds.push(staff.leadAnalystMedicaidId);
          behaviorTechnicianMedicaidIds.push(staff.behaviorTechnicianMedicaidId);
        });
        let renderingProviderNames = [];
        appointmentData.appointmentRenderingProviders.forEach((staff) => {
          renderingProviderNames.push(staff.renderingProviderName);
        });
        let staffID = staffIds && staffIds.length ? staffIds[0] : null;
        this.setState({
          appointmentTypeName: appointmentData.appointmentTypeName,
          appointmentDate: showFormatedDate(appointmentData.startDateTime),
          appointmentTime: showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime),
          staffName: staffNames && staffNames ? staffNames.join(',') : '',
          renderingProviderName: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
          serviceFacility: appointmentData.serviceFacility,
          isDirectService: appointmentData.isDirectService,
          PatientLocationName: appointmentData.address,
          patient_id: appointmentData.patientID,
          staffID: staffID,          
          timeDifference: appointmentData.timeDifference,
          targetCaseManager: appointmentData.targetCaseManager,             
          medicaidId: medicaidIds && medicaidIds ? medicaidIds.join(',') : '',
          leadAnalystMedicaidId : leadAnalystMedicaidIds && leadAnalystMedicaidIds ? leadAnalystMedicaidIds.join(',') : '',
          behaviorTechnicianMedicaidId : behaviorTechnicianMedicaidIds && behaviorTechnicianMedicaidIds ? behaviorTechnicianMedicaidIds.join(',') : '', 
        });

        let soapObj = nextProps.singleEncounter;
        let guardianSignObj = {}, clientSignObj = {}, employeeSignObj = {}, renderingProviderSignObj = {};
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              guardianSignObj = data;
            }
            if (signObj.patientSign) {
              let data = {
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: nextProps.singleEncounter.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              clientSignObj = data;
            }
            if (signObj.clinicianSign) {
              let data = {
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: staffNames && staffNames ? staffNames.join(',') : '',
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              employeeSignObj = data;
            }
            if (signObj.renderingProviderSign) {
              let data = {
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                Name: renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '',
                //Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              renderingProviderSignObj = data;
            }
          });
        }
        let signeeArray = [];
        this.setState({
          ClientSign: clientSignObj,
          GuardianSign: guardianSignObj,
          EmployeeSign: employeeSignObj,
          RenderingProviderSign: renderingProviderSignObj,
        });
        if (!(clientSignObj && clientSignObj.Bytes)) {
          // signeeArray.push({ id: 1, value: 'Client' });
        }
        if (!(guardianSignObj && guardianSignObj.Bytes)) {
          signeeArray.push({ id: 2, value: 'Guardian' });
        }
        this.setState({ Signee: signeeArray });
      }
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,     
      });
    }

  }

  renderDiagnosis() {
    if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else {
      if (this.props.initialValues.diagnosisArray && this.props.initialValues.diagnosisArray.length !== 0) {
        return this.props.initialValues.diagnosisArray.map((diagnosis, index) => {
          if (diagnosis.IsDeleted) {
            return <tr key={index}><td colSpan='3'><span className='redfont'>{diagnosis.description}</span></td></tr>;
          }
          return (
            <TableRow key={index}>
              <TableRowColumn width="30%">{diagnosis.icdCode}</TableRowColumn>
              <TableRowColumn width="70%">{diagnosis.description ? diagnosis.description : '-'}</TableRowColumn>
              {/* <td width="10%"><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont">Remove</button></td>*/}
            </TableRow>
          );
        });
      }
    }
  }


  renderCpt() {
    if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    } else if (this.props.initialValues.CPTTableData && this.props.initialValues.CPTTableData.length !== 0) {
      return this.props.initialValues.CPTTableData.map((cpt, index) => {
        if (cpt.IsDeleted) {
          return <tr key={index}><td colSpan='3'><span className='redfont'>{cpt.serviceCode}</span></td></tr>;
        }
        return (
          <TableRow key={index}>
            <TableRowColumn>{cpt.serviceCode ? cpt.serviceCode : '-'}</TableRowColumn>
            <TableRowColumn>{cpt.description ? cpt.description : '-'}</TableRowColumn>
          </TableRow>
        );
      });
    }
  }

  handleBackClick = () => {
    history.push(`/my-appointment/${this.props.singleEncounter.patientID}`);
  };

  handleOpenSign= () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };

  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    let signeeArray = this.state.Signee;
    switch (formProps.Signee) {
    case 1:
      data.Name = formProps.ClientName;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ ClientSign: data, Signee: signeeArray.splice(0, 1) });
      this.saveEncounterSigns(0, null, data, null);
      break;
    case 2:
      data.Name = formProps.GuardianName;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ GuardianSign: data, Signee: signeeArray.splice(1, 1) });
      this.saveEncounterSigns(0, null, null, data);
      break;
    default:
      break;
    }
  };

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  render() {
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });

    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {/* <PatientInfo patientId={this.state.patientid} /> */}
        <div className="clearfix"></div>
        {this.state.openSign ?
          <SignatureModal Signee={this.state.Signee} clientName={this.props.singleEncounter ? this.props.singleEncounter.patientName : ''} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="readmin-panel">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <RaisedButton className="soapmodal_btn mt-20" label="Back" primary={true} onTouchTap={this.handleBackClick} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p> */}
                      <p>
                        <b>Session Duration (In Mins):</b> <span>{this.state.timeDifference}</span>
                      </p>
                      <p>
                        <b>Targeted Case Manager:</b> <span>{this.state.targetCaseManager}</span>
                      </p>
                      <p>
                        <b>Medicaid ID:</b> <span>{this.state.medicaidId}</span>
                      </p>
                      <p>
                        <b>Lead Analyst Medicaid ID:</b> <span>{this.state.leadAnalystMedicaidId}</span>
                      </p>
                      <p>
                        <b>Behavior Technician Medicaid ID:</b> <span>{this.state.behaviorTechnicianMedicaidId}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    disabled={true}
                    fullWidth={true}
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    component={renderTimePicker}
                    selected={this.props.initialValues.serviceEndTime}
                    onDateChange={this.onDateChange}
                    disabled={true}
                    fullWidth={true}
                  />
                </div>
                {/* <div className='col-sm-6'>
                  <Field
                    name="TargetCaseManager"
                    type="text"
                    fullWidth={true}
                    label="Target Case Manager"                  
                    disabled={true}
                    component={renderTextField}                   
                  />   
                </div>  */}
              </div>
             

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>RBT Session Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className={'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForReduction"
                    type="text"
                    fullWidth={true}
                    label="Target Behaviors For Reduction"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                  />
                </div>                   
                <div className={'col-sm-12'} >
                  <Field
                    name="TargetBehaviorsForIncrease"
                    type="text"
                    fullWidth={true}
                    label="Replacement Skills for Increase"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}                  
                  />
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin require">
                    <h6><b>Behavior Analysis Service Delivery: </b>Under direct observation/training of BCBA, Registered Behavior Technician provided training to client, direct care supports and/or family, regarding implementation of all components of the BSP to include replacement skill procedures, decel procedures, antecedent/environmental manipulations, and data collection/documentation, through a combination of role-play, modeling, feedback and coaching in the home, community, and school settings.</h6>
                  </div>   
                  <div className="panel_title no_margin require mb-20">
                    <h6><b>See data sheets for specific programs implemented and data collected.</b></h6>
                  </div>                  
                </div>
              </div>
              
              <div className="row">                
                <div className="col-sm-12 require">
                  <span>***Equipment utilized </span>
                  <Field
                    autoFocus={true}
                    name="NoEquipmentUtilized"
                    type="text"
                    maxLength="100"                    
                    label="Equipment Utilized"
                    component={renderTextField}
                    disabled={true}
                    />
                </div>
              </div>
              <div className="row">                
                <div className="col-sm-12 require">
                  <span>***Supplies utilized: </span>
                  <Field
                    autoFocus={true}
                    name="SuppliesUtilized"
                    type="text"
                    maxLength="100"                    
                    label="Supplies Utilized"
                    component={renderTextField} 
                    disabled={true}
                    />
                    <span> reinforcers (edibles, potables, tangibles)</span>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Training Addressed During Session</h5><span style={{ color: 'red'}}>*</span>                    
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Consistency"
                    label="Consistency - Caregiver/s"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ChoiceMaking"
                    label="Choices/Choice Making"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="InterventionPlan"
                    label="Intervention Plan"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AutonomyInformation"
                    label="Autonomy Information"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="JunkBehavior"
                    label="Junk Behavior"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="CommunityIntegration"
                    label="Affiliation/Community Integration"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>

                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Reinforcement"
                    label="Reinforcement"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Confidentiality"
                    label="Confidentiality"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FunctionalCommunication"
                    label="Functional Communication"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FreeFromAbuseAndNeglect"
                    label="Free from Abuse And Neglect"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SettingExpectations"
                    label="Setting Expectations w/ Client/Caregiver"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ConsumerPreferences"
                    label="Consumer Preferences/Dislikes"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="RoleModeling"
                    label="Role Modeling - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SafeAndSafeGuards"
                    label="Safe And Safeguards"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Monitoring"
                    label="Monitoring/Feedback - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="IndividualRights"
                    label="Individual Rights And Fair Treatment"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis/Data Entry"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="HealthAndWellness"
                    label="Health And Wellness"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Feedback"
                    label="Feedback - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ReviewClientChoice"
                    label="Review Clients Choice of Time, Date, and Place for Services Rendered"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ObservationalAssessment"
                    label="Observational Assessment - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Relaxation"
                    label="Relaxation/Calming Skills - CBA"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTrainingAddressed"
                    label="Other: ABC Data Collection"
                    disabled={true}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTrainingAddressed &&
                  (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTrainingAddressedNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={true}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className={'col-sm-12'} >
                  <Field
                    name="BehaviorIncidents"
                    type="text"
                    fullWidth={true}
                    label="Behavior Incidents: Description of behaviors targeted for decrease/replacement skills utilized/interventions utilized:"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="SkillAcquisition"
                    type="text"
                    fullWidth={true}
                    label="Skill Acquisition"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="Communication"
                    type="text"
                    fullWidth={true}
                    label="Communication"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="Adaptive"
                    type="text"
                    fullWidth={true}
                    label="Adaptive"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                {/* <div className={'col-sm-12'} >
                  <Field
                    name="BehaviorReplacementSkills"
                    type="text"
                    fullWidth={true}
                    label="Behavior Replacement Skills"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div> */}
                <div className={'col-sm-12'} >
                  <Field
                    name="ChoicesOffered"
                    type="text"
                    fullWidth={true}
                    label="Choices Offered: Choices offered during session to client e.g. reinforcers, location of therapy, activities used for programming etc.: "
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="CaregiverInvolvement"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Involvement: Narrative of caregiver participation and feedback given to caregiver:"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>

                <div className={'col-sm-12'} >
                  <Field
                    name="CaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Caregiver Homework"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="FollowUpCaregiverHomework"
                    type="text"
                    fullWidth={true}
                    label="Follow Up Caregiver Homework"
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
                <div className={'col-sm-12'} >
                  <Field
                    name="ChangesToClientStatus"
                    type="text"
                    fullWidth={true}
                    label="Changes to client status: List any changes to client's mental, physical or medical status. Include changes with medication, living status, etc. "
                    // autoHeight={true}
                    disabled={true}
                    component={renderTextArea}
                    
                  />
                </div>
              </div>
            
             

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Diagnosis</h3>
                    <i className="flaticon flaticon-gym"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn width="20%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderDiagnosis()}
                  </TableBody>
                </Table>
              </div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Service Codes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <Table className={tableClass1}
                  height={this.state.height}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                      <TableHeaderColumn>Service Code</TableHeaderColumn>
                      <TableHeaderColumn>Description</TableHeaderColumn>
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderCpt()}
                  </TableBody>
                </Table>
              </div>
              {/* {this.props.isSoapRendered && this.state.Signee.length ?
                <div className="row">
                  <div className="col-sm-12 pt20">
                    <RaisedButton className="soapmodal_btn" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  </div>
                </div>
                : ''} */}
                {this.state.GuardianSign.Bytes ?
                  '':
                  <div className="row">
                    <div className="col-sm-12 pt20">
                      <RaisedButton className="soapmodal_btn" label="Add Sign"  primary={true} onTouchTap={this.handleOpenSign} />
                    </div>
                  </div>
                }
              { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
                <div className="row">
                  <div className="col-12">
                    <div className="panel_title mt-24  mb-20">
                      <h3>Signature</h3>
                      <i className="flaticon flaticon-medical-1"></i>
                    </div>
                  </div>
                  {
                    this.state.EmployeeSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageEmployee">

                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                                <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                  }
                  {this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">
                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                  }
                  {this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                  }
                  {this.state.RenderingProviderSign.Bytes ?
                      <div className="col-sm-12 col-md-4">
                        <div id="showCanvasImageClient">
                          <div className="row">
                            <div className="col-12">
                              <div className="sign">
                                <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                                <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                                <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                                {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                                <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      : ''
                    }
                </div>
                : ''}

            </form>
          </div>
        </div>
      </div>
    );
  }
}
const selector = formValueSelector('EncounterForm');
EncounterForm = reduxForm({
  form: 'EncounterForm',
  enableReinitialize: true,
})(EncounterForm);
function mapStateToProps(state) {
  let initialData = {};
  let appointmentTime = null
    , encounterDetail = state.patientPortal.encounter_detail && state.patientPortal.encounter_detail.data ? state.patientPortal.encounter_detail.data : null;
  // console.log(encounterDetail);
  if (encounterDetail) {
    

    if (encounterDetail.sessionNotes_RBT_TFABA) {
      
      initialData['TargetBehaviorsForReduction'] = encounterDetail.sessionNotes_RBT_TFABA.targetBehaviorsForReduction;
      initialData['TargetBehaviorsForIncrease'] = encounterDetail.sessionNotes_RBT_TFABA.targetBehaviorsForIncrease;
      initialData['BehaviorIncidents'] = encounterDetail.sessionNotes_RBT_TFABA.behaviorIncidents;
      initialData['SkillAcquisition'] = encounterDetail.sessionNotes_RBT_TFABA.skillAcquisition;
      initialData['Communication'] = encounterDetail.sessionNotes_RBT_TFABA.communication;
      initialData['Adaptive'] = encounterDetail.sessionNotes_RBT_TFABA.adaptive;
      //initialData['BehaviorReplacementSkills'] = encounterDetail.sessionNotes_RBT_TFABA.behaviorReplacementSkills;
      initialData['ChoicesOffered'] = encounterDetail.sessionNotes_RBT_TFABA.choicesOffered;
      initialData['CaregiverInvolvement'] = encounterDetail.sessionNotes_RBT_TFABA.caregiverInvolvement;
      initialData['CaregiverHomework'] = encounterDetail.sessionNotes_RBT_TFABA.caregiverHomework;
      initialData['FollowUpCaregiverHomework'] = encounterDetail.sessionNotes_RBT_TFABA.followUpCaregiverHomework;
      initialData['ChangesToClientStatus'] = encounterDetail.sessionNotes_RBT_TFABA.changesToClientStatus;
      //initialData['TargetCaseManager'] = encounterDetail.sessionNotes_RBT_TFABA.targetCaseManager;

      // TrainingAddressed       

      initialData['Consistency'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consistency;
      initialData['ChoiceMaking'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].choiceMaking;
      initialData['InterventionPlan'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].interventionPlan;
      initialData['AutonomyInformation'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].autonomyInformation;
      initialData['JunkBehavior'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].junkBehavior;
      initialData['CommunityIntegration'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].communityIntegration;
      initialData['Reinforcement'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reinforcement;
      initialData['Confidentiality'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].confidentiality;
      initialData['FunctionalCommunication'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].functionalCommunication;
      initialData['FreeFromAbuseAndNeglect'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].freeFromAbuseAndNeglect;
      initialData['SettingExpectations'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].settingExpectations;
      initialData['ConsumerPreferences'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].consumerPreferences;
      initialData['RoleModeling'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].roleModeling;
      initialData['SafeAndSafeGuards'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].safeAndSafeGuards;
      initialData['Monitoring'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].monitoring;
      initialData['IndividualRights'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].individualRights;
      initialData['TaskAnalysis'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].taskAnalysis;
      initialData['HealthAndWellness'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].healthAndWellness;
      initialData['Feedback'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].feedback;
      initialData['ReviewClientChoice'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].reviewClientChoice;
      initialData['ObservationalAssessment'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].observationalAssessment;
      initialData['Relaxation'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].relaxation;
      initialData['OtherTrainingAddressed'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressed;
      initialData['OtherTrainingAddressedNotes'] = encounterDetail.sessionNotes_RBT_TFABA.tfabA_RBT_TrainingAddressed[0].otherTrainingAddressedNotes;
     
   
  }

    if (encounterDetail.patientEncounterDiagnosisCodes) {
      initialData['diagnosisArray'] = encounterDetail.patientEncounterDiagnosisCodes;
    }
    if (encounterDetail.patientEncounterServiceCodes) {
      initialData['CPTTableData'] = encounterDetail.patientEncounterServiceCodes;
    }

    // if(encounterDetail.appointmentStartDateTime){
    //   let startTimehours = encounterDetail.appointmentStartDateTime.substr(11, 2);
    //   let endTimehours = encounterDetail.appointmentEndDateTime.substr(11, 2);
    //   let formattedStartTimehours = parseInt(startTimehours) >= 12 ?
    //     (parseInt(startTimehours) - 12 < 10 ?
    //       `0${parseInt(startTimehours) - 12}`
    //       : startTimehours)
    //     : startTimehours;
    //   let formattedEndTimehours = parseInt(endTimehours) >= 12 ? (parseInt(endTimehours) - 12 < 10 ? `0${parseInt(endTimehours) - 12}` : endTimehours) : endTimehours;
    //   let AmPmOfStartTime = parseInt(startTimehours) >= 12 ? 'pm' : 'am';
    //   let AmPmOfEndTime = parseInt(endTimehours) >= 12 ? 'pm' : 'am';
    //   appointmentTime = `${formattedStartTimehours}:${encounterDetail.appointmentStartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.appointmentEndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
    //   initialData['appointmentTime'] = appointmentTime;
    // }

    // console.log('encounterDetail.............', encounterDetail);

    if (encounterDetail.startDateTime) {
      let startTimehours = encounterDetail.startDateTime.substr(11, 2);
      let endTimehours = encounterDetail.endDateTime.substr(11, 2);
      let formattedStartTimehours = parseInt(startTimehours, 10) >= 12 ? (parseInt(startTimehours, 10) - 12 < 10 ? `0${parseInt(startTimehours, 10) - 12}` : startTimehours) : startTimehours;
      let formattedEndTimehours = parseInt(endTimehours, 10) >= 12 ? (parseInt(endTimehours, 10) - 12 < 10 ? `0${parseInt(endTimehours, 10) - 12}` : endTimehours) : endTimehours;

      let AmPmOfStartTime = parseInt(startTimehours, 10) >= 12 ? 'pm' : 'am';
      let AmPmOfEndTime = parseInt(endTimehours, 10) >= 12 ? 'pm' : 'am';
      appointmentTime = `${formattedStartTimehours}:${encounterDetail.startDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${encounterDetail.endDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      initialData['appointmentTime'] = appointmentTime;
    }


    initialData['locationName'] = encounterDetail.locationName;
    initialData['staffName'] = encounterDetail.staffName;
    initialData['appointmentDate'] = encounterDetail.patientAppointment.startDateTime;
    initialData['PatientLocationName'] = encounterDetail.PatientLocationName;
    initialData['serviceEndTime'] = moment(encounterDetail.patientAppointment.endDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.endDateTime).format('HH:mm:ss');
    initialData['serviceStartTime'] = moment(encounterDetail.patientAppointment.startDateTime).format('YYYY-MM-DD') + 'T' + moment(encounterDetail.patientAppointment.startDateTime).format('HH:mm:ss');

  }
  let isSoapRendered = false;
  if (encounterDetail && encounterDetail.status && encounterDetail.status.toLowerCase() === 'rendered') {
    isSoapRendered = true;
  }

  return {
    selectorOtherTrainingAddressed: selector(state, 'OtherTrainingAddressed'),

    singleEncounter: encounterDetail,
    isSoapRendered: isSoapRendered,
    initialValues: initialData,
    master_data: state.soap.master_data,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
  };
}
export default connect(mapStateToProps, { getPatientSingleEncounter, savePatientEncounter, saveEncounterSigns, getMasterData, getGeoLocation })(EncounterForm);



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/details/components/patient_sessionnotes_RBT_TFABA.js